import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  Button,
  Card,
  Chip,
  ClickAwayListener,
  IconButton,
  InputAdornment,
  Paper,
  Popper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import Box from "@mui/material/Box";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Clear } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { errorToast, successToast } from "../../helpers/toast";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import Pagination from "../../components/Pagination";
import WarnModal from "../../components/WarnModal";
import { useDeleteByIdAmenitiesMutation } from "../../services/amenities";
import EditKeyModal from "../../components/EditWarnModal";
import { Visibility } from "@mui/icons-material";
import { useLazyGetXmlRecordsQuery } from "../../services/property";
import moment from "moment";
import { DayPicker } from "react-day-picker";

const ManageRecords = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState<any[]>([]);
  const [getRecords] = useLazyGetXmlRecordsQuery();
  const { id } = useParams();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const onPageChange = (newPage: number) => {
    setPage(newPage);
    setRows([]);
  };
  const [totalCount, setTotalCount] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  let totalPages = Math.ceil(totalCount / limit);
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [open1, setOpen1] = useState(false); // Control calendar visibility
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedChip, setSelectedChip] = useState("");
  const [month, setMonth] = useState(new Date());
  const [range, setRange] = useState<{
    from: Date | undefined;
    to: Date | undefined;
  }>({
    from: undefined,
    to: undefined,
  });

  const handleClose = () => {
    setOpen1(false);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen1(true);
  };

  const getFormattedRange = () => {
    if (range?.from && range?.to) {
      return `${moment(range.from).format("MM/DD/YYYY")} - ${moment(
        range.to
      ).format("MM/DD/YYYY")}`;
    } else if (range?.from) {
      return moment(range.from).format("MM/DD/YYYY");
    }
    return "";
  };

  const handleSelect = (selectedRange: any) => {
    if (selectedRange === undefined) {
      setRange({ from: undefined, to: undefined });
    } else {
      setRange(selectedRange);
    }
  };

  const handleChipClick = (value: any) => {
    if (value === selectedChip) {
      setSelectedChip("");
      setRange({ from: undefined, to: undefined });
      setMonth(moment().toDate());
      return;
    }
    setSelectedChip(value);

    let newRange = { from: moment().toDate(), to: moment().toDate() };
    const today = moment();

    if (value === "lastMonth") {
      newRange = {
        from: moment().subtract(1, "months").startOf("month").toDate(),
        to: moment().subtract(1, "months").endOf("month").toDate(),
      };
    } else if (value === "lastWeek") {
      newRange = {
        from: moment().subtract(7, "days").startOf("day").toDate(),
        to: today.toDate(),
      };
    } else if (value === "lastYear") {
      newRange = {
        from: moment().subtract(1, "years").startOf("year").toDate(),
        to: moment().subtract(1, "years").endOf("year").toDate(),
      };
    }
    setRange(newRange);
    setMonth(newRange.from);
  };

  const handleMonthChange = (newMonth: any) => {
    setMonth(newMonth);
  };

  const [deleteCategory] = useDeleteByIdAmenitiesMutation();

  const naviagteFun = () => {
    navigate(`/manage-amenities/edit/${selectedId}`);
  };

  const fetchRecords = async () => {
    try {
      const res = await getRecords({
        companyId: id,
        page: page,
        search: debouncedSearchTerm,
        limit: limit,
        startDate: range?.from
          ? moment(range?.from).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]")
          : "",
        endDate: range?.to
          ? moment(range?.to).endOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]")
          : "",
      }).unwrap();
      if (res?.statusCode === 200) {
        setRows(res?.data?.rows || []);
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleDeleteCategory = async (userId: any) => {
    try {
      const response = await deleteCategory({ userId }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Amenity deleted successfully");
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.message || error?.data?.message);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, [page, limit, debouncedSearchTerm, range]);

  return (
    <div>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">XML Overview Records</h1>
          <Button
            onClick={() => navigate("/xml-overview", { replace: true })}
            className="btn btn_primary"
          >
            Back
          </Button>
        </div>
        {/* <Loader isLoad=} /> */}
        <Card className="cards">
          <Box className="cards_header">
            <Box className="cards_header_left">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                    setTimeout(() => {
                      setPage(1);
                    }, 1000);
                  }
                }}
              />
              <div className="control_group" style={{ width: "250px" }}>
                <TextField
                  // label="Select Date Range"
                  variant="outlined"
                  hiddenLabel
                  className="text_field-range"
                  fullWidth
                  onClick={handleClick}
                  value={getFormattedRange()}
                  placeholder="Select Date Range"
                  InputProps={{
                    readOnly: true,
                    endAdornment: range?.from ? (
                      <InputAdornment
                        position="end"
                        style={{ marginLeft: -50 }}
                      >
                        <IconButton
                          onClick={() => {
                            setRange({
                              from: undefined,
                              to: undefined,
                            });
                          }}
                        >
                          <Clear />
                        </IconButton>
                      </InputAdornment>
                    ) : (
                      <InputAdornment position="end">
                        <IconButton>
                          <CalendarTodayIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <Popper
                open={open1}
                anchorEl={anchorEl}
                placement="bottom-start"
                disablePortal
                style={{
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <Paper
                    elevation={3}
                    style={{ position: "relative", zIndex: 1 }}
                  >
                    <div
                      style={{
                        padding: 16,
                        borderRadius: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                        }}
                      >
                        <Chip
                          label="Last Week"
                          variant={
                            selectedChip === "lastWeek" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastWeek")}
                        />
                        <Chip
                          label="Last Month"
                          variant={
                            selectedChip === "lastMonth" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastMonth")}
                        />
                        <Chip
                          label="Last Year"
                          variant={
                            selectedChip === "lastYear" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastYear")}
                        />
                      </div>

                      <DayPicker
                        className="react-day-picker"
                        mode="range"
                        selected={range}
                        onSelect={handleSelect}
                        // numberOfMonths={10}
                        month={month}
                        onMonthChange={handleMonthChange}
                      />
                    </div>
                  </Paper>
                </ClickAwayListener>
              </Popper>
            </Box>
          </Box>
          <TableContainer className="table_container">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>Date & Time</TableCell>
                  {/* <TableCell>Total Properties</TableCell> */}
                  <TableCell>Current XML Properties</TableCell>
                  <TableCell>Previous Published Properties</TableCell>
                  <TableCell>Live Published Properties </TableCell>
                  <TableCell>Deleted Properties </TableCell>
                  <TableCell>Listing Action Tracker </TableCell>
                  <TableCell>Unpublished Properties </TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.length == 0 ? (
                  <TableRow>
                    <TableCell colSpan={12} align="center">
                      No Record found
                    </TableCell>
                  </TableRow>
                ) : (
                  rows?.map((row: any, index: any) => (
                    <TableRow key={row?._id}>
                      <TableCell align="center">
                        {" "}
                        {(page - 1) * 10 + index + 1}
                      </TableCell>
                      <TableCell>
                        {row?.createdAt
                          ? moment(row?.createdAt).format("LLL")
                          : "-"}
                      </TableCell>

                      {/* <TableCell>{row?.totalProperties || "-"}</TableCell> */}
                      <TableCell>{row?.xmlCount || "-"}</TableCell>
                      <TableCell>
                        {row?.previouslyPublishedProperties || "-"}
                      </TableCell>
                      <TableCell>{row?.liveProperties || "-"}</TableCell>
                      <TableCell>{row?.xmlDeletedProperties || "-"}</TableCell>
                      <TableCell>
                        {row?.listingActionTrackerProperties || "-"}
                      </TableCell>
                      <TableCell>{row?.unpublishedProperties || "-"}</TableCell>

                      <TableCell>
                        <Box className="table_actions">
                          <Tooltip title="View Properties">
                            <IconButton
                              onClick={() => {
                                navigate(
                                  `/xml-overview-details/${row?._id}/${id}`
                                );
                              }}
                            >
                              <Visibility />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </div>
      {rows?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          onPageChange={onPageChange}
          limit={limit}
          setLimit={setLimit}
          totalPages={totalPages}
        />
      ) : (
        ""
      )}
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDeleteCategory(selectedId)}
        name="Amenity"
      />
      <EditKeyModal
        open={openEdit}
        setOpen={setOpenEdit}
        navigate={naviagteFun}
      />
    </div>
  );
};

export default ManageRecords;
